import React from 'react';

const initialValues = {
  activeClientDocs: [],
  activeClientDocMap: new Map(),
  /**
   * `isReady` means the roster loaded *successfully*, not merely that the fetch settled. A
   * failed fetch stays not-ready with `hasError` set, so consumers hold their loading state
   * instead of rendering an empty client list that is indistinguishable from a coach who
   * genuinely has none — and can tell "loaded, empty" from "failed" when they want to say so.
   */
  isReady: false,
  hasError: false,
};

const ActiveClientsContext = React.createContext(initialValues);

export default ActiveClientsContext;
export {
  initialValues,
};
